var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "profile-content-container" }, [
    _vm.loading
      ? _c("div", { staticClass: "background" }, [
          _vm.loading
            ? _c("div", { staticClass: "logo-position lds-circle" }, [
                _vm._m(0),
              ])
            : _vm._e(),
        ])
      : _vm._e(),
    !_vm.loading
      ? _c("div", { staticClass: "content" }, [
          _c("div", { staticClass: "content-left" }, [
            _c("div", { staticClass: "main-information" }, [
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    width: "100%",
                    "justify-content": "space-between",
                    "align-items": "center",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: { display: "flex", "align-items": "center" },
                    },
                    [
                      _vm.profile.profile
                        ? _c("img", {
                            staticClass: "img",
                            attrs: { src: _vm.profile.profile },
                          })
                        : _vm._e(),
                      !_vm.profile.profile
                        ? _c("img", {
                            staticClass: "img",
                            attrs: { src: _vm.cardUserImage },
                          })
                        : _vm._e(),
                      _c("div", [
                        _c("h4", [
                          _vm._v(
                            _vm._s(_vm.profile.name + " " + _vm.profile.surname)
                          ),
                        ]),
                        _c("h4", [
                          _vm._v(
                            _vm._s(_vm.lastQualification.degree) +
                              " (" +
                              _vm._s(_vm.lastQualification.year) +
                              ")"
                          ),
                        ]),
                        _c("h5", [
                          _vm._v(_vm._s(_vm.lastQualification.institution)),
                        ]),
                        _vm.profile && _vm.profile.careerTrack
                          ? _c("p", { staticClass: "tag-pill" }, [
                              _vm._v(_vm._s(_vm.profile.careerTrack)),
                            ])
                          : _vm._e(),
                      ]),
                    ]
                  ),
                  _c(
                    "md-button",
                    {
                      staticClass: "btn-text",
                      staticStyle: { height: "fit-content !important" },
                      on: { click: _vm.toggleFavourite },
                    },
                    [
                      _c(
                        "md-icon",
                        {
                          staticClass: "btn-text-icon",
                          class: { favourited: _vm.isFavourited },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.isFavourited ? "star" : "star_border"
                              ) +
                              " "
                          ),
                        ]
                      ),
                      _vm._v(" " + _vm._s(_vm.favouriteButtonText) + " "),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c(
              "div",
              { staticClass: "document-container border" },
              [
                _vm.profile && _vm.profile.cv && _vm.profile.cv.url
                  ? _c(
                      "md-button",
                      {
                        staticClass: "btn-text",
                        on: { click: _vm.viewResume },
                      },
                      [
                        _c("md-icon", { staticClass: "btn-text-icon" }, [
                          _vm._v("description"),
                        ]),
                        _vm._v(" View Resume "),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.profile.videoSubmissionUrl
                  ? _c(
                      "md-button",
                      {
                        staticClass: "btn-text",
                        on: { click: _vm.viewVideoSubmission },
                      },
                      [
                        _c("md-icon", { staticClass: "btn-text-icon" }, [
                          _vm._v("videocam"),
                        ]),
                        _vm._v(" Video Submissions "),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.profile.writtenSubmissionUrl
                  ? _c(
                      "md-button",
                      {
                        staticClass: "btn-text",
                        on: { click: _vm.viewWrittenSubmission },
                      },
                      [
                        _c("md-icon", { staticClass: "btn-text-icon" }, [
                          _vm._v("description"),
                        ]),
                        _vm._v(" Written Submissions "),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
            _vm.skillsAssessmentResults.length > 0
              ? _c("div", { staticClass: "section-container border" }, [
                  _c(
                    "h4",
                    { staticClass: "section-title" },
                    [
                      _c("md-icon", [_vm._v("assignment ")]),
                      _vm._v(" Skills Assessment"),
                    ],
                    1
                  ),
                  _c("table", { staticClass: "assessment-table" }, [
                    _vm._m(1),
                    _c(
                      "tbody",
                      _vm._l(
                        _vm.skillsAssessmentResults,
                        function (result, index) {
                          return _c("tr", { key: index }, [
                            _c("td", [_vm._v(_vm._s(result.skillName))]),
                            _c("td", [
                              result.status === "Not Attempted"
                                ? _c("span", [_vm._v("Not Attempted")])
                                : _c("span", [
                                    _vm._v(_vm._s(result.percentage) + "%"),
                                  ]),
                            ]),
                          ])
                        }
                      ),
                      0
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm.profile.introductoryVideoUrl
              ? _c("div", { staticClass: "video-container border" }, [
                  _c(
                    "h4",
                    [
                      _c("md-icon", [_vm._v("videocam")]),
                      _vm._v(" Introductory Video"),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "video-player",
                      class: { blurred: !this.auth },
                    },
                    [
                      [
                        _c("iframe", {
                          attrs: {
                            src: _vm.embeddedVideoUrl,
                            width: "100%",
                            height: "100%",
                            frameborder: "0",
                            allowfullscreen: "",
                            allow:
                              "camera; microphone; fullscreen; display-capture",
                          },
                        }),
                      ],
                    ],
                    2
                  ),
                  !this.auth
                    ? _c(
                        "button",
                        {
                          staticClass: "login-overlay-button",
                          on: { click: _vm.promptLogin },
                        },
                        [_vm._v("Log in to view")]
                      )
                    : _vm._e(),
                ])
              : _vm._e(),
            _vm.profile.qualifications.length > 0
              ? _c(
                  "div",
                  { staticClass: "section-container border" },
                  [
                    _c(
                      "h4",
                      { staticClass: "section-title" },
                      [
                        _c("md-icon", [_vm._v("school ")]),
                        _vm._v(" Education"),
                      ],
                      1
                    ),
                    _vm._l(
                      _vm.profile.qualifications,
                      function (qualification, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "section-card" },
                          [
                            _c("div", { staticClass: "section-left" }, [
                              _c("h3", [_vm._v(_vm._s(qualification.degree))]),
                              _c("h4", [
                                _vm._v(_vm._s(qualification.institution)),
                              ]),
                              _c("h4", [
                                _vm._v(
                                  "Year of Study: " + _vm._s(qualification.year)
                                ),
                              ]),
                            ]),
                            _c(
                              "div",
                              [
                                _c("h4", [
                                  _vm._v(
                                    " " +
                                      _vm._s(qualification.startDate) +
                                      " - " +
                                      _vm._s(
                                        qualification.endDate &&
                                          qualification.endDate !==
                                            "Invalid date"
                                          ? qualification.endDate
                                          : "Present"
                                      ) +
                                      " "
                                  ),
                                ]),
                                qualification.academicTranscript &&
                                qualification.academicTranscript.url
                                  ? _c(
                                      "md-button",
                                      {
                                        staticClass: "btn-text",
                                        on: {
                                          click: function ($event) {
                                            return _vm.viewAcademicTranscript(
                                              qualification.academicTranscript
                                                .url
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "md-icon",
                                          { staticClass: "btn-text-icon" },
                                          [_vm._v("file_download")]
                                        ),
                                        _vm._v(" View Transcript "),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]
                        )
                      }
                    ),
                  ],
                  2
                )
              : _vm._e(),
            _vm.profile.experiences.length > 0
              ? _c("div", { staticClass: "section-container border" }, [
                  _c(
                    "h4",
                    { staticClass: "section-title" },
                    [_c("md-icon", [_vm._v("school ")]), _vm._v(" Experience")],
                    1
                  ),
                  _c(
                    "div",
                    { class: { blurred: !this.auth } },
                    _vm._l(
                      _vm.profile.experiences,
                      function (experience, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "section-card" },
                          [
                            _c("div", { staticClass: "section-left" }, [
                              _c("h3", [_vm._v(_vm._s(experience.jobTitle))]),
                              _c(
                                "h4",
                                { staticStyle: { "margin-bottom": "1rem" } },
                                [_vm._v(_vm._s(experience.employer))]
                              ),
                              _c("p", [_vm._v(_vm._s(experience.description))]),
                            ]),
                            _c("div", [
                              _c("h4", { staticClass: "section-dates" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(experience.startDate) +
                                    " - " +
                                    _vm._s(
                                      experience.endDate &&
                                        experience.endDate !== "Invalid date"
                                        ? experience.endDate
                                        : "Present"
                                    ) +
                                    " "
                                ),
                              ]),
                            ]),
                          ]
                        )
                      }
                    ),
                    0
                  ),
                  !this.auth
                    ? _c(
                        "button",
                        {
                          staticClass: "login-overlay-button",
                          on: { click: _vm.promptLogin },
                        },
                        [_vm._v("Log in to view")]
                      )
                    : _vm._e(),
                ])
              : _vm._e(),
            _c("br"),
            _c("br"),
          ]),
          _c("div", { staticClass: "content-right" }, [
            _c("div", { staticClass: "section-box contact" }, [
              _c(
                "h4",
                { staticClass: "section-header" },
                [
                  _c("md-icon", [_vm._v("call")]),
                  _vm._v(" Contact Information"),
                ],
                1
              ),
              _c("div", { class: { blurred: !this.auth } }, [
                _c("p", [_vm._v("Email: " + _vm._s(_vm.profile.email))]),
                _c("p", [_vm._v("Phone: " + _vm._s(_vm.profile.phone))]),
                _vm.profile &&
                _vm.profile.location &&
                _vm.profile.location.formattedAddress
                  ? _c("p", [
                      _vm._v(
                        "Location: " +
                          _vm._s(_vm.profile.location.formattedAddress)
                      ),
                    ])
                  : _vm._e(),
              ]),
              !this.auth
                ? _c(
                    "button",
                    {
                      staticClass: "login-overlay-button",
                      on: { click: _vm.promptLogin },
                    },
                    [_vm._v("Log in to view")]
                  )
                : _vm._e(),
            ]),
            _c("div", { staticClass: "section-box" }, [
              _c(
                "h4",
                { staticClass: "section-header" },
                [_c("md-icon", [_vm._v("build")]), _vm._v(" Skills")],
                1
              ),
              _vm.passedSkills.length
                ? _c(
                    "div",
                    { staticClass: "section-content wrap" },
                    _vm._l(_vm.passedSkills, function (skill) {
                      return _c(
                        "p",
                        { key: skill.id, staticClass: "tag-pill" },
                        [_vm._v(" " + _vm._s(skill.id) + " ")]
                      )
                    }),
                    0
                  )
                : _c("p", [_vm._v("No passed skills found")]),
            ]),
            _vm.profile &&
            _vm.profile.preferredCompanies &&
            _vm.profile.preferredCompanies.choices &&
            _vm.profile.preferredCompanies.choices.length > 0
              ? _c("div", { staticClass: "section-box" }, [
                  _c(
                    "h4",
                    { staticClass: "section-header" },
                    [
                      _c("md-icon", [_vm._v("business")]),
                      _vm._v(" Preferred Companies"),
                    ],
                    1
                  ),
                  _vm.profile &&
                  _vm.profile.preferredCompanies &&
                  _vm.profile.preferredCompanies.choices &&
                  _vm.profile.preferredCompanies.choices.length > 0
                    ? _c(
                        "ul",
                        _vm._l(
                          _vm.profile.preferredCompanies.choices,
                          function (preferred_company, index) {
                            return _c("li", { key: index }, [
                              _vm._v(" " + _vm._s(preferred_company) + " "),
                            ])
                          }
                        ),
                        0
                      )
                    : _c("p", [_vm._v("No Preferred Companies Data Found")]),
                ])
              : _vm._e(),
            _vm.profile &&
            _vm.profile.preferredCompanies &&
            _vm.profile.preferredCompanies.department &&
            _vm.profile.preferredCompanies.department.length > 0
              ? _c("div", { staticClass: "section-box" }, [
                  _c(
                    "h4",
                    { staticClass: "section-header" },
                    [
                      _c("md-icon", [_vm._v("business")]),
                      _vm._v(" Preferred Departments"),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "section-content wrap" },
                    _vm._l(
                      _vm.profile.preferredCompanies.department,
                      function (preferred_department, index) {
                        return _c(
                          "p",
                          { key: index, staticClass: "tag-pill" },
                          [
                            _vm._v(
                              " " +
                                _vm._s(preferred_department.department) +
                                " "
                            ),
                          ]
                        )
                      }
                    ),
                    0
                  ),
                ])
              : _vm._e(),
          ]),
        ])
      : _vm._e(),
    this.auth
      ? _c(
          "div",
          { staticClass: "section-box no-top-margin" },
          [
            _vm.status === "jobs"
              ? _c("applicant-comments-modal", {
                  attrs: { userProfile: _vm.userProfile, jobId: _vm.jobId },
                })
              : _vm._e(),
            _vm.isTalentPool &&
            _vm.currentTalentPool &&
            _vm.userProfile &&
            _vm.userProfile.userId
              ? _c("talent-pool-comments-modal", {
                  attrs: {
                    userProfile: _vm.userProfile,
                    currentTalentPool: _vm.currentTalentPool,
                    isTalentPool: _vm.isTalentPool,
                  },
                })
              : _vm._e(),
            _c(
              "h4",
              { staticClass: "section-header" },
              [
                _c("md-icon", [_vm._v("chat_bubble_outline")]),
                _vm._v(" Notes & Comments"),
              ],
              1
            ),
            _c("textarea", {
              staticClass: "comment-input",
              attrs: {
                name: "comments",
                id: "comments",
                cols: "30",
                rows: "4",
                placeholder: "Add notes about this candidate...",
              },
            }),
            _c(
              "md-button",
              { staticClass: "btn-text full-width" },
              [
                _c("md-icon", { staticClass: "btn-text-icon" }, [
                  _vm._v("add_circle_outline"),
                ]),
                _vm._v(" Save Comment"),
              ],
              1
            ),
          ],
          1
        )
      : _vm._e(),
    _vm.errorAuth
      ? _c(
          "div",
          [
            _c("modal", {
              scopedSlots: _vm._u(
                [
                  {
                    key: "body",
                    fn: function () {
                      return [
                        _c("div", [_c("p", [_vm._v(_vm._s(_vm.authError))])]),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "footer",
                    fn: function () {
                      return [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "flex-direction": "row",
                              "justify-content": "space-between",
                            },
                          },
                          [
                            _c(
                              "md-button",
                              {
                                staticClass: "md-primary",
                                staticStyle: {
                                  color: "white !important",
                                  "margin-right": "20px",
                                },
                                on: { click: _vm.promptLogin },
                              },
                              [_vm._v("Login")]
                            ),
                            _c(
                              "md-button",
                              {
                                staticClass: "md-danger",
                                staticStyle: { color: "white !important" },
                                on: {
                                  click: function ($event) {
                                    _vm.errorAuth = false
                                  },
                                },
                              },
                              [_vm._v("Cancel")]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ],
                null,
                false,
                383485706
              ),
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("img", { attrs: { src: require("@/assets/img/logo.png") } }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [_c("th", [_vm._v("Skill")]), _c("th", [_vm._v("Score")])]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }